export const defaultConfig = {
    "caseHeaders": [
        {
            "table": "intake",
            "name": "CaseType",
            "label": "Case Type",
            "width": 200
        },
        {
            "table": "client",
            "name": "FirstName",
            "label": "First Name",
            "width": 150
        },
        {
            "table": "client",
            "name": "LastName",
            "label": "Last Name",
            "width": 150
        },
        {
            "table": "intake",
            "name": "CaseNumber",
            "label": "Case Number",
            "width": 300
        },
        {
            "table": "payment",
            "name": "Fee",
            "label": "Flat Fee",
            "width": 80
        },
        {
            "table": "payment",
            "name": "FeeOwed",
            "label": "Total Fee",
            "width": 80
        },
        {
            "table": "payment",
            "name": "FeeUnpaid",
            "label": "Unpaid",
            "width": 80
        },
        {
            "table": "payment",
            "name": "FeePaid",
            "label": "Paid",
            "width": 80
        },
        {
            "table": "intake",
            "name": "CreatedDate",
            "label": "Case Created",
            "width": 100
        }],

    "clientHeaders": [
        {
            "table": "client",
            "name": "ClientType",
            "label": "Contact Type",
            "width": 150
        },
        {
            "table": "client",
            "name": "FirstName",
            "label": "First Name",
            "width": 150
        },
        {
            "table": "client",
            "name": "LastName",
            "label": "Last Name",
            "width": 150
        },
        {
            "table": "client",
            "name": "Email",
            "label": "Email",
            "width": 150
        },
        {
            "table": "client",
            "name": "Phone",
            "label": "Phone",
            "width": 150
        },
        {
            "table": "client",
            "name": "CreatedDate",
            "label": "Client Created",
            "width": 100
        }],

    "notesEmailTemplates": [],

    "caseStates": [{
        type: "Lead",
    }],

    "client": [
        {
            "type": "Client",
            "tables": [
                {
                    "table": "client",
                    "fields": [
                        {
                            "name": "FirstName",
                            "type": "TextInput",                            
                            "visibility": ['ALL'],
                            "props": {
                                "required": true,
                                "label": "First Name"
                            }
                        },
                        {
                            "name": "MiddleName",
                            "type": "TextInput",                            
                            "visibility": ['ALL'],
                            "props": {
                                "label": "Middle Name"
                            }
                        },
                        {
                            "name": "LastName",
                            "type": "TextInput",                            
                            "visibility": ['ALL'],
                            "props": {
                                "required": true,
                                "label": "Last Name"
                            }
                        },
                        {
                            "name": "Email",
                            "type": "Email",                            
                            "visibility": ['ALL'],
                            "props": {
                                "required": true,
                                "label": "Email"
                            }
                        },
                        {
                            "name": "Phone",
                            "type": "Phone",                            
                            "visibility": ['ALL'],
                            "props": {
                                "required": true,
                                "label": "Phone"
                            }
                        },
                        {
                            "name": "Referral",
                            "type": "Choice",
                            "props": {
                                "label": "Referral",
                                "customEnabled": false,
                                "help": "How did you hear about us?",
                                "options": ["Search engine (Google, Bing, ...)", "From a Friend", "Facebook", "LinkedIn", "Other"]
                            },                            
                            "visibility": ['ALL']
                        },
                        {
                            "name": "Street",
                            "type": "TextInput",                            
                            "visibility": ['Traffic Infraction', 'DUI'],
                            "props": {
                                "label": "Street"
                            }
                        },
                        {
                            "name": "City",
                            "type": "TextInput",                            
                            "visibility": ['Traffic Infraction', 'DUI'],
                            "props": {
                                "label": "City"
                            }
                        },
                        {
                            "name": "State",
                            "type": "State",                            
                            "visibility": ['Traffic Infraction', 'DUI'],
                            "props": {
                                "label": "State"
                            }
                        },
                        {
                            "name": "ZIP",
                            "type": "ZIP",                            
                            "visibility": ['Traffic Infraction', 'DUI'],
                            "props": {
                                "label": "ZIP"
                            }
                        },
                        {
                            "name": "Birthday",
                            "type": "DateInput",                            
                            "visibility": ['DUI'],
                            "props": {
                                "label": "Date of Birth"
                            }
                        },
                        {
                            "name": "SSN",
                            "type": "SSN",                            
                            "visibility": ['DUI'],
                            "props": {
                                "label": "SSN"
                            }
                        },
                        {
                            "name": "EmergencyName",
                            "type": "TextInput",                            
                            "visibility": ['DUI'],
                            "props": {
                                "label": "Emergency contact name"
                            }
                        },
                        {
                            "name": "EmergencyPhone",
                            "type": "Phone",                            
                            "visibility": ['DUI'],
                            "props": {
                                "label": "Emergency contact phone"
                            }
                        },
                        {
                            "name": "CreatedDate",
                            "type": "Hidden",
                            "props": {
                                "label": "Client Created"
                            },
                            "visibility": ['ALL'],
                        },
                    ]
                },
            ],
        },
        {
            "type": "Court",
            "tables": [
                {
                    "table": "client",
                    "fields": [
                        {
                            "name": "FirstName",
                            "type": "TextInput",
                            "props": {
                                "label": "First Name",
                                "required": true
                            }
                        },
                        {
                            "name": "MiddleName",
                            "type": "TextInput",
                            "props": {
                                "label": "Middle Name",
                            }
                        },
                        {
                            "name": "LastName",
                            "type": "TextInput",
                            "props": {
                                "label": "Last Name",
                            }
                        },
                        {
                            "name": "Email",
                            "type": "TextInput",
                            "props": {
                                "label": "Email",
                                "required": false
                            },
                            "publicHidden": false,                            
                        },
                        {
                            "name": "FaxNo",
                            "type": "Fax",
                            "props": {
                                "label": "Fax",
                                "required": false
                            },
                            "publicHidden": false
                        }
                    ]
                }
            ]
        }
    ],

    "workflow": [
    {
        "type": "None",
        "tables": [
            {
                "table": "intake",
                "fields": [
                    {
                        "name": "PublicIntakeDate",
                        "type": "Hidden",
                        "props": {
                            "label": "Public Intake Date"
                        }
                    },
                    {
                        "name": "CaseNumber",
                        "type": "TextInput",
                        "props": {
                            "label": "Case Number",
                            "required": true
                        },
                        "publicHidden": true
                    },
                    {
                        "name": "Description",
                        "type": "TextArea",
                        "props": {
                            "rows": "3",
                            "label": "Description",
                            "required": false
                        },
                        "publicHidden": false,                        
                    },
                    {
                        "name": "CreatedDate",
                        "type": "Hidden",
                        "props": {
                            "label": "Case Created"
                        },
                        "publicHidden": true
                    }
                ]
            },
        ]
    },
    {
        "type": "Traffic Infraction",
        "tables": [
        {
            "table": "intake",
            "fields": [
                {
                    "name": "PublicIntakeDate",
                    "type": "Hidden",
                    "props": {
                        "label": "Public Intake Date"
                    }
                },
                {
                    "name": "CaseType",
                    "type": "CaseType",
                    "props": {
                        "required": true,
                        "label": "Case Type"
                    }
                },
                {
                    "name": "CaseNumber",
                    "type": "TextInput",
                    "props": {
                        "required": false,
                        "label": "Case Number"
                    }
                },
                {
                    "name": "Charges",
                    "type": "TextInput",
                    "props": {
                        "label": "Charges"
                    }
                },
                {
                    "name": "ViolationDate",
                    "type": "DateInput",
                    "props": {
                        "label": "Violation Date"
                    }
                },
                {
                    "name": "DrivingLicenseNo",
                    "type": "TextInput",                    
                    "props": {
                        "label": "Driving License Number"
                    }
                },
                {
                    "name": "DrivingLicenseState",
                    "type": "State",                    
                    "props": {
                        "label": "Driving License State of Issue",
                        "help": "What state was your driving license issued in?"
                    }
                },
                {
                    "name": "CommercialDrivingLicense",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Commercial Driving License",
                        "help": "Do you hold a commercial driving license?"
                    }
                },
                {
                    "name": "IntermediateDrivingLicense",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Intermediate Driving License",
                        "help": "Do you hold an intermediate driving license?"
                    }
                },
                {
                    "name": "DeferredFinding",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Deferred Finding",
                        "help": "Are you currently on a deferred finding?"
                    }
                },
                {
                    "name": "CourtDate",
                    "type": "DateInput",
                    "$New$": true,
                    "props": {
                        "help": "",
                        "label": "Court Date",
                        "required": false
                    },
                    "publicHidden": true,                    
                },
                {
                    "name": "Description",
                    "type": "TextArea",
                    "props": {
                        "rows": "3",
                        "label": "Description",
                        "required": false
                    },
                    "publicHidden": false,                    
                },
                {
                    "name": "CreatedDate",
                    "type": "Hidden",
                    "props": {
                        "label": "Case Created"
                    }
                }
            ]
        },
        ],
        "tasklist": [
            {
                "id": -1,
                "Title": "{extra.ClientFullName} - Send contract and payment request",
                "error": {},
                "Chrono": "tomorrow 9am",
                "OrderId": -2,
                "version": 0,
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "DateTimeEnd": "Invalid date",
                "Description": "",
                "DeadlineType": {
                    "type": "chrono",
                    "label": "Relative date/time/range",
                    "showTime": true,
                    "showChrono": true,
                    "showDateEnd": true,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Awaiting Payment and Signature",
                "ActionPerformed": false,
                "ChronoReference": "task.CreatedDate"
            },
            {
                "id": -2,
                "Title": "{extra.ClientFullName} - Verify payment received",
                "OrderId": -3,
                "version": 0,
                "BlockedBy": "-1",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Preparing Initial Docs",
                "ActionPerformed": false
            },
            {
                "id": -3,
                "Title": "{extra.ClientFullName} - Prepare and send NOA and RFD",
                "OrderId": -4,
                "version": 0,
                "BlockedBy": "-2",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionCaseState": "Awaiting Court Date",
                "ActionPerformed": false
            },
            {
                "id": -4,
                "Title": "{extra.ClientFullName} - Set court date",
                "error": {},
                "OrderId": -5,
                "version": 0,
                "BlockedBy": "-3",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "DateTimeEnd": "Invalid date",
                "Description": "",
                "DeadlineType": {
                    "type": "chrono",
                    "label": "Relative date/time/range",
                    "showTime": true,
                    "showChrono": true,
                    "showDateEnd": true,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Trial Processing",
                "ActionPerformed": false,
                "ChronoReference": "intake.CourtDate"
            },
            {
                "id": -6,
                "Title": "{extra.ClientFullName} - Email client case resolution",
                "OrderId": -7,
                "version": 0,
                "BlockedBy": "-4",
                "Completed": false,
                "ActionType": "none",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionPerformed": false
            }
        ]
    },
    {
        "type": "DUI",
        "tables": [
        {
            "table": "intake",
            "fields": [
                {
                    "name": "PublicIntakeDate",
                    "type": "Hidden",
                    "props": {
                        "label": "Public Intake Date"
                    }
                },
                {
                    "name": "CaseType",
                    "type": "CaseType",
                    "props": {
                        "required": true,
                        "label": "Case Type"
                    }
                },
                {
                    "name": "CaseNumber",
                    "type": "TextInput",
                    "props": {
                        "required": false,
                        "label": "Case Number"
                    }
                },
                {
                    "name": "Charges",
                    "type": "TextInput",
                    "props": {
                        "label": "Charges"
                    }
                },
                {
                    "name": "ViolationDate",
                    "type": "DateInput",
                    "props": {
                        "label": "Violation Date"
                    }
                },
                {
                    "name": "DrivingLicenseNo",
                    "type": "TextInput",                    
                    "props": {
                        "label": "Driving License Number"
                    }
                },
                {
                    "name": "DrivingLicenseState",
                    "type": "State",                    
                    "props": {
                        "label": "Driving License State of Issue",
                        "help": "What state was your driving license issued in?"
                    }
                },
                {
                    "name": "CommercialDrivingLicense",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Commercial Driving License",
                        "help": "Do you hold a commercial driving license?"
                    }
                },
                {
                    "name": "BreathTest",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Breath Test",
                        "help": "Did you take the breath test?"
                    }
                },
                {
                    "name": "BreathTestValue",
                    "type": "TextInput",                    
                    "props": {
                        "label": "What did you blow?",
                        "help": "If you did the breath test, what did you blow?"
                    }
                },
                {
                    "name": "DolFormMailed",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Mailed DOL form?",
                        "help": "Have you mailed DOL hearing request form?"
                    }
                },
                {
                    "name": "OtherCharges",
                    "type": "YesNoRadio",                    
                    "props": {
                        "label": "Other charges",
                        "help": "Are you being charged with anything else besides DUI?"
                    }
                },
                {
                    "name": "Description",
                    "type": "TextArea",                    
                    "props": {
                        "label": "What happened?",
                        "rows": 10,
                        "help": "Please describe in your own words what happened?"
                    }
                },
                {
                    "name": "CourtDate",
                    "type": "DateInput",
                    "$New$": true,
                    "props": {
                        "help": "",
                        "label": "Court Date",
                        "required": false
                    },
                    "publicHidden": true,                    
                },
                {
                    "name": "CreatedDate",
                    "type": "Hidden",                    
                    "props": {
                        "label": "Case Created"
                    }
                }
            ]
        },
        ],
        "tasklist": [
            {
                "id": -1,
                "Title": "{extra.ClientFullName} - Send contract and payment request",
                "error": {},
                "Chrono": "now",
                "OrderId": -2,
                "version": 0,
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "DateTimeEnd": "Invalid date",
                "Description": "",
                "DeadlineType": {
                    "type": "chrono",
                    "label": "Relative date/time/range",
                    "showTime": true,
                    "showChrono": true,
                    "showDateEnd": true,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Awaiting Payment and Signature",
                "ActionPerformed": false,
                "ChronoReference": "task.CreatedDate"
            },
            {
                "id": -2,
                "Title": "{extra.ClientFullName} - Verify payment received",
                "OrderId": -3,
                "version": 0,
                "BlockedBy": "-1",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Preparing Initial Docs",
                "ActionPerformed": false
            },
            {
                "id": -3,
                "Title": "{extra.ClientFullName} - Prepare and send NOA and RFD",
                "OrderId": -4,
                "version": 0,
                "BlockedBy": "-2",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionCaseState": "Awaiting Court Date",
                "ActionPerformed": false
            },
            {
                "id": -4,
                "Title": "{extra.ClientFullName} - Set court date",
                "error": {},
                "Chrono": "now",
                "OrderId": -5,
                "version": 0,
                "BlockedBy": "-3",
                "Completed": false,
                "ActionType": "set_case_state",
                "ActionError": "",
                "DateTimeEnd": "Invalid date",
                "Description": "",
                "DeadlineType": {
                    "type": "chrono",
                    "label": "Relative date/time/range",
                    "showTime": true,
                    "showChrono": true,
                    "showDateEnd": true,
                    "showDateStart": false
                },
                "ActionTrigger": "completed",
                "ActionCaseState": "Trial Processing",
                "ActionPerformed": false,
                "ChronoReference": "intake.CourtDate"
            },
            {
                "id": -6,
                "Title": "{extra.ClientFullName} - Email client case resolution",
                "OrderId": -7,
                "version": 0,
                "BlockedBy": "-4",
                "Completed": false,
                "ActionType": "none",
                "ActionError": "",
                "Description": "",
                "DeadlineType": {
                    "type": "none",
                    "showTime": false,
                    "showDateEnd": false,
                    "showDateStart": false
                },
                "ActionPerformed": false
            }
        ]
    }],
    "caseStates": [
        {
            "type": "Lead"
        },
        {
            "type": "Awaiting Payment and Signature"
        },
        {
            "type": "Preparing Initial Docs"
        },
        {
            "type": "Awaiting Court Date"
        },
        {
            "type": "Trial Processing"
        },
        {
            "type": "Decided"
        }
    ],
};


export const defaultWorkflow =
{
    "type": "New Workflow",
    "tables": [
    {
        "table": "intake",
        "fields": [
            {
                "name": "PublicIntakeDate",
                "type": "Hidden",
                "props": {
                    "label": "Public Intake Date"
                }
            },
            {
                "name": "CaseType",
                "type": "CaseType",
                "props": {
                    "required": true,
                    "label": "Case Type"
                }
            },
            {
                "name": "CaseNumber",
                "type": "TextInput",
                "props": {
                    "required": false,
                    "label": "Case Number"
                }
            },
            {
                "name": "Charges",
                "type": "TextInput",
                "props": {
                    "label": "Charges"
                }
            },
            {
                "name": "CreatedDate",
                "type": "Hidden",
                "props": {
                    "label": "Case Created"
                }
            }
        ]
    },
    {
        "table": "client",
        "fields": [
            {
                "name": "FirstName",
                "type": "TextInput",                
                "props": {
                    "required": true,
                    "label": "First Name"
                }
            },
            {
                "name": "MiddleName",
                "type": "TextInput",                
                "props": {
                    "label": "Middle Name"
                }
            },
            {
                "name": "LastName",
                "type": "TextInput",                
                "props": {
                    "required": true,
                    "label": "Last Name"
                }
            },
            {
                "name": "Referral",
                "type": "Choice",
                "props": {
                    "label": "Referral",
                    "customEnabled": true,
                    "help": "How did you hear about us?"
                },                
            },
            {
                "name": "Email",
                "type": "Email",                
                "props": {
                    "required": true,
                    "label": "Email"
                }
            },
            {
                "name": "Phone",
                "type": "Phone",                
                "props": {
                    "required": true,
                    "label": "Phone"
                }
            },
            {
                "name": "Street",
                "type": "TextInput",                
                "props": {
                    "label": "Street"
                }
            },
            {
                "name": "City",
                "type": "TextInput",                
                "props": {
                    "label": "City"
                }
            },
            {
                "name": "State",
                "type": "State",                
                "props": {
                    "label": "State"
                }
            },
            {
                "name": "ZIP",
                "type": "ZIP",                
                "props": {
                    "label": "ZIP"
                }
            },
            {
                "name": "Birthday",
                "type": "DateInput",                
                "props": {
                    "label": "Date of Birth"
                }
            },
            {
                "name": "CreatedDate",
                "type": "Hidden",                
                "props": {
                    "label": "Client Created"
                }
            }
        ]
    },
    {
        "table": "payment",
        "fields": [
            {
                "name": "Fee",
                "type": "Cash",
                "props": {
                    "label": "Fee"
                }
            },
            {
                "name": "Paid",
                "type": "DateInput",
                "props": {
                    "label": "Paid Date"
                }
            },
            {
                "name": "Signed",
                "type": "DateInput",
                "props": {
                    "label": "Signed Date"
                }
            }
        ]
    },
    {
        "table": "docs",
        "fields": []
    },
    {
        "table": "notes",
        "fields": [
            {
                "name": "Notes",
                "type": "TextArea",
                "props": {
                    "label": "Notes",
                    "rows": 10
                }
            },
            {
                "name": "CaseState",
                "type": "CaseState",
                "props": {
                    "label": "Case State"
                }
            }
        ]
    }
    ]
};

export const defaultClientType = 'Client';

export const defaultClient =
{
    "type": "New Contact",
    "tables": [
    {
        "table": "client",
        "fields": [
            {
                "name": "ClientType",
                "type": "ClientType",
                "props": {
                    "label": "Contact Type"
                }
            },
            {
                "name": "FirstName",
                "type": "TextInput",
                "props": {
                    "required": true,
                    "label": "First Name"
                }
            },
            {
                "name": "MiddleName",
                "type": "TextInput",
                "props": {
                    "label": "Middle Name"
                }
            },
            {
                "name": "LastName",
                "type": "TextInput",
                "props": {
                    "label": "Last Name"
                }
            },
            {
                "name": "Email",
                "type": "Email",
                "props": {
                    "label": "Email"
                }
            },
            {
                "name": "Phone",
                "type": "Phone",
                "props": {
                    "label": "Phone"
                }
            },
            {
                "name": "CreatedDate",
                "type": "Hidden",
                "props": {
                    "label": "Created"
                }
            }
        ]
    }]
};